export default __webpack_public_path__ + "static/media/earrings.c5bf39ee.webp";